import Icon from '../components/Icon.vue'

Icon.register({
  'file-powerpoint': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M193.7 271.2c8.8 0 15.5 2.7 20.3 8.1 9.6 10.9 9.8 32.7-0.2 44.1-4.9 5.6-11.9 8.5-21.1 8.5h-26.9v-60.7h27.9zM377 105c4.5 4.5 7 10.6 7 16.9v6.1h-128v-128h6c6.4 0 12.5 2.5 17 7zM224 136c0 13.2 10.8 24 24 24h136v328c0 13.3-10.7 24-24 24h-336c-13.3 0-24-10.7-24-24v-464c0-13.3 10.7-24 24-24h200v136zM277 301.2c0-44.2-28.4-77-72.9-77h-81c-6.6 0-12 5.4-12 12v199.8c0 6.6 5.4 12 12 12h30.8c6.6 0 12-5.4 12-12v-57.2c22.3 0 111.1 12.7 111.1-77.6z'
      }
    ]
  }
})
